
// export const BE_URL = "http://localhost:5100/";
export const BE_URL = "http://5.196.81.32:8080/"; // Proxy forwards to port 5100 internally
// export const BE_URL = "https://ai-app.esmed.org/";

